module.exports = __webpack_public_path__ + "img/mute_icon.9a9953ac.svg";